module.exports = __webpack_public_path__ + "static/media/manager-r-6.a53977e6.png";